"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmountUnitFactor = exports.numberToString = exports.stringToNumber = exports.isValidNumberRange = exports.stringToRangeArray = exports.isValidNumber = exports.roundToPrecision = void 0;
//https://github.com/BenjaminVanRyseghem/numbro/issues/403 (need to use numbro.default and different import until this is closed.)
// import numbro from 'numbro';
const numbro = require("numbro");
const numbroAny = numbro;
let numbroWorkaround;
if (numbroAny.default !== undefined) {
    numbroWorkaround = numbroAny.default;
}
else {
    numbroWorkaround = numbroAny;
}
function roundToPrecision(value, precision) {
    const scale = Math.pow(10, precision);
    return Math.round(value * scale) / scale;
}
exports.roundToPrecision = roundToPrecision;
function isValidNumber(valueStr) {
    return numbroWorkaround.validate(valueStr.toLowerCase(), {});
}
exports.isValidNumber = isValidNumber;
function stringToRangeArray(valueStr) {
    if (valueStr) {
        const splits = valueStr.split('-');
        if (splits.length === 2) {
            const start = parseInt(splits[0].trim(), 10);
            const end = parseInt(splits[1].trim(), 10);
            if (Number.isFinite(start) && Number.isFinite(end)) {
                return [start, end];
            }
        }
    }
    return [];
}
exports.stringToRangeArray = stringToRangeArray;
function isValidNumberRange(valueStr) {
    const array = stringToRangeArray(valueStr);
    return (array && array.length === 2 && array[0] < array[1]);
}
exports.isValidNumberRange = isValidNumberRange;
function stringToNumber(valueStr) {
    return numbroWorkaround(valueStr.toLowerCase()).value();
}
exports.stringToNumber = stringToNumber;
function numberToString(value, format) {
    return numbroWorkaround(value).format(format);
}
exports.numberToString = numberToString;
function getAmountUnitFactor(amountUnit) {
    if (amountUnit === 'AMOUNT') {
        return 1;
    }
    else if (amountUnit === 'THOUSAND') {
        return 1000;
    }
    else if (amountUnit === 'MILLION') {
        return 1000000;
    }
    else if (amountUnit === 'BILLION') {
        return 1000000000;
    }
    else if (amountUnit === 'LAKH') {
        return 100000;
    }
    else if (amountUnit === 'CRORE') {
        return 10000000;
    }
    else {
        return 1;
    }
}
exports.getAmountUnitFactor = getAmountUnitFactor;
//# sourceMappingURL=number-utils.js.map